import { BaseComponent } from 'src/app/core/abstracts/components/base.component';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Injector } from '@angular/core';
import { ApiService } from 'src/app/core/services/api/api.service';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { DateUtil } from 'src/app/shared/library/px-ui/px-forms/utils';
import { AppError } from 'src/app/shared/library/px-ui/px-forms/models';

export abstract class FormComponent extends BaseComponent {
    private form: UntypedFormGroup;
    private readonly apiService: ApiService;
    private readonly formBuilder: UntypedFormBuilder;
    public exportResultObjectForIE;
    private readonly sanitizer: DomSanitizer;

    private innerMappingCandidates: {
        [key: string]: { from: (value: string) => string; to: (value: string) => string };
    };

    get mappingCandidates() {
        return this.innerMappingCandidates;
    }

    set mappingCandidates(value) {
        this.innerMappingCandidates = value;
    }

    dateMappingProvider = { from: (value) => DateUtil.fromService(value), to: (value) => DateUtil.toService(value) };

    set formGroup(form: UntypedFormGroup) {
        this.form = form;
    }

    get formGroup() {
        return this.form;
    }

    get f() {
        return this.formBuilder;
    }

    protected constructor(injector: Injector) {
        super(injector);

        this.formBuilder = injector.get(UntypedFormBuilder, null);
        this.apiService = injector.get(ApiService, null);
        this.sanitizer = injector.get(DomSanitizer, null);
    }

    saveWithBody(path: string, body) {
        return this.apiService.post(path, body);
    }

    save(path: string) {
        if (this.formGroup.valid) {
            const data = this.formGroup.value;
            if (this.mappingCandidates) {
                Object.keys(this.mappingCandidates).forEach((key) => {
                    if (this.formGroup.get(key)) {
                        data[key] = this.mappingCandidates[key].to(this.formGroup.get(key).value);
                    }
                });
            }
            return this.apiService.post(path, data);
        }

        this.formGroup.markAllAsTouched();
        return throwError('Validierungsfehler');
    }

    load<T extends {}>(path: string, payload) {
        return this.apiService.post(path, payload).pipe(
            map((data: T) => {
                if (!this.mappingCandidates) {
                    return data;
                }

                Object.keys(this.mappingCandidates).forEach((key) => {
                    if (key in data) {
                        data[key] = this.mappingCandidates[key].from(data[key]);
                    }
                });
                return data;
            })
        );
    }

    initFormGroup(controls: {
        [key: string]: (string | ((control: AbstractControl) => { [key: string]: AppError })[])[];
    }) {
        this.form = this.f.group(controls);
    }

    dataURItoBlob(dataURI) {
        if (!dataURI) {
            return;
        }
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        return new Blob([int8Array], { type: 'application/pdf' });
    }

    buildUrl(keyData) {
        const blob = this.dataURItoBlob(this.storeService.getData(keyData)?.file);
        if (!blob) {
            return;
        }
        return this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
    }
}
